import api from '@/services/Api';
import Reiseziel from '@/types/Reiseziel';
import { successSwal } from '@/helper/swals';
import { ActionContext, Module } from 'vuex';
import { AxiosResponse } from 'axios';
import { ReisezieleState, RootState } from '@/store/types';

export type ReisezieleFilter = { gueltig: string };
export type LoadReisezielePayload = { filter: ReisezieleFilter };
export type UpdateReisezielPayload = { reiseziel: Reiseziel; filter: ReisezieleFilter };
export type DeleteReisezielPayload = { reiseziel: Reiseziel; filter: ReisezieleFilter };

type Context = ActionContext<ReisezieleState, RootState>;

export const reiseziele: Module<ReisezieleState, RootState> = {
    namespaced: true,
    state: {
        dialogs: {
            edit: false,
        },
        loaders: {
            save: false,
            delete: false,
            reiseziele: false,
        },
        reiseziele: [],
    },
    actions: {
        loadReiseziele({ commit }: Context, payload?: LoadReisezielePayload): void {
            commit('setLoadersReiseziele', true);
            commit('setReiseziele', []);

            api.post('verwaltung/reiseziele/load', payload)
                .then((response: AxiosResponse) => commit('setReiseziele', response.data.body))
                .catch(console.error)
                .finally(() => commit('setLoadersReiseziele', false));
        },
        updateReiseziel({ commit, dispatch }: Context, { reiseziel, filter }: UpdateReisezielPayload): void {
            commit('setLoadersSave', true);

            api.post('verwaltung/reiseziele/speichern', reiseziel)
                .then(() => {
                    successSwal('Reiseziel', 'gespeichert');
                    dispatch('loadReiseziele', { filter });
                    commit('setDialogsDetail', false);
                })
                .catch(console.error)
                .finally(() => commit('setLoadersSave', false));
        },
        deleteReiseziel({ commit, dispatch }: Context, { reiseziel, filter }: DeleteReisezielPayload): void {
            commit('setLoadersDelete', true);

            api.post('verwaltung/reiseziele/loeschen', reiseziel)
                .then(() => {
                    successSwal('Reiseziel', 'gelöscht');
                    dispatch('loadReiseziele', { filter });
                    commit('setDialogsDetail', false);
                })
                .catch(console.error)
                .finally(() => commit('setLoadersDelete', false));
        },
    },
    mutations: {
        setReiseziele(state: ReisezieleState, payload: Partial<Reiseziel>[]): void {
            state.reiseziele = payload.map((data) => new Reiseziel(data));
        },
        setDialogsDetail(state: ReisezieleState, visible: boolean): void {
            state.dialogs.edit = visible;
        },
        setLoadersSave(state: ReisezieleState, visible: boolean): void {
            state.loaders.save = visible;
        },
        setLoadersDelete(state: ReisezieleState, visible: boolean): void {
            state.loaders.delete = visible;
        },
        setLoadersReiseziele(state: ReisezieleState, visible: boolean): void {
            state.loaders.reiseziele = visible;
        },
    },
};
